// extracted by mini-css-extract-plugin
module.exports = {"container":"_1HJzFcW4-xXAtyJui1Gm_3","video":"_3uwDPhnX8eNTWtCKqS2RON","icon":"zK1xuVcHzwmUQ2eTgaNwx","buttonActive":"Y0Mem_8gcXkH7_vIdmLno"};